import * as THREE from 'three';
import gsap from 'gsap';

const nav = () => {
  const el = document.querySelector('.nav-hero-img');
  const imgs = Array.from(el.querySelectorAll('img'));
  const dispImage = el.dataset.displacement;
  const image1 = imgs[0].getAttribute('src');
  const image2 = imgs[1].getAttribute('src');
  const intensity = -0.65;
  const speedIn = 0.5;
  const speedOut = 0.5;
  const userHover =  true;

  //Scene
  const scene = new THREE.Scene();

  //Camera
  const camera = new THREE.OrthographicCamera(
    el.offsetWidth / -2,
    el.offsetWidth / 2,
    el.offsetHeight / 2,
    el.offsetHeight / -2,
    1,
    1000
  );
  camera.position.z = 1;

  const vertex = `
    varying vec2 vUv;

    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
  `;

  const fragment = `
    varying vec2 vUv;

    uniform sampler2D texture;
    uniform sampler2D texture2;
    uniform sampler2D disp;

    uniform float dispFactor;
    uniform float effectFactor;

    void main() {
        vec2 uv = vUv;
        vec4 disp = texture2D(disp, uv);

        vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y);
        vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y);

        vec4 _texture = texture2D(texture, distortedPosition);
        vec4 _texture2 = texture2D(texture2, distortedPosition2);

        vec4 finalTexture = mix(_texture, _texture2, dispFactor);

        gl_FragColor = finalTexture;
    }
  `;

  //Renderer
  const renderer = new THREE.WebGLRenderer({ antialias: false});
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0xffffff, 0.0);
  renderer.setSize(el.offsetWidth, el.offsetHeight);
  el.appendChild(renderer.domElement);

  const loader = new THREE.TextureLoader();

  const texture1 = loader.load(image1);
  const texture2 = loader.load(image2);
  const disp = loader.load(dispImage);

  disp.wrapS = disp.wrapT = THREE.RepeatWrapping;

  //Filters
  texture1.magFilter = texture2.magFilter = THREE.LinearFilter;
  texture1.minFilter = texture2.minFilter = THREE.LinearFilter;
  texture1.anisotropy = 1;
  texture2.anisotropy = 1;

  //Shader Material
  const material = new THREE.ShaderMaterial({
    uniforms: {
      effectFactor: { type: "f", value: intensity },
      dispFactor: { type: "f", value: 0.0 },
      texture: { type: "t", value: texture1 },
      texture2: { type: "t", value: texture2 },
      disp: { type: "t", value: disp }
    },

    vertexShader: vertex,
    fragmentShader: fragment,
    transparent: true,
    opacity: 1.0
  });

  const geometry = new THREE.PlaneGeometry(
    el.offsetWidth,
    el.offsetHeight,
    1
  );

  const object = new THREE.Mesh(geometry, material);
  scene.add(object);

  const addEvents = () => {
      const evtIn = "mouseenter";
      const evtOut = "mouseleave";

      el.addEventListener(evtIn, () => {
        gsap.to(material.uniforms.dispFactor, {
          duration: speedIn,
          value: 1,
          ease: "expo.out"
        });
      });

      el.addEventListener(evtOut, () => {
        gsap.to(material.uniforms.dispFactor, {
          duration: speedOut,
          value: 0,
          ease: "expo.out"
        });
      });
  };

  if (userHover) {
      addEvents();
  }

  window.addEventListener("resize", () => {
      renderer.setSize(el.offsetWidth, el.offsetHeight);
  });

  const animate = () => {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
  };

  animate();

  const navItems = document.querySelectorAll('.nav__item');
  const nav = document.querySelector('.nav');
  const pull = document.querySelector('.header__pull');

  navItems.forEach(navItem => {
    navItem.addEventListener('click', () => {
      nav.classList.remove('open');
      pull.classList.remove('closed');
    })
  })
}


export default nav;
